export default __webpack_public_path__ + "static/media/female_ovary.34185cc5.png";